// @flow

import React, {Component} from 'react';

export type Props = {
  checked: ?boolean,
  onChange: Function,
};

export default class Checkbox extends Component<Props> {
  props: Props;

  el: any;

  componentDidMount() {
    this.el.indeterminate = this.props.checked === null;
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.checked !== this.props.checked) {
      this.el.indeterminate = this.props.checked === null;
    }
  }

  render() {
    const {checked, ...attrs} = this.props;
    return (
      <input
        ref={el => {this.el = el;}}
        type="checkbox"
        checked={!!checked}
        {...attrs} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js